import { InfiniteScrollSentinel } from "@circle-react-shared/InfiniteScrollSentinel";
import { Typography } from "@circleco/compass/components/Typography";

import { t } from "@/i18n-js/instance";

import { ChatListRow } from "./ChatListRow";
import {
  groupChatsByRecency,
  type ChatRecencyBucket,
} from "./groupChatsByRecency";
import { useAvatarChats } from "./useAvatarChats";

const recencyBucketLabel = (bucket: ChatRecencyBucket) => {
  const labels = {
    today: t("today"),
    yesterday: t("yesterday"),
    past_week: t("avatars.conversation_panel.past_week"),
    past_30_days: t("avatars.conversation_panel.past_30_days"),
    older: t("avatars.conversation_panel.older"),
  };

  return labels[bucket];
};

export const ChatsList = () => {
  const { chats, fetchNextPage, hasNextPage } = useAvatarChats();

  if (chats.length === 0) return null;

  return (
    <section
      aria-label={t("avatars.conversation_panel.chats_title")}
      className="flex shrink-0 flex-col gap-10"
    >
      {groupChatsByRecency(chats).map(({ bucket, chats: bucketChats }) => (
        <div key={bucket} className="flex flex-col">
          <Typography
            variant="label-sm"
            component="h3"
            color="tertiary"
            className="pb-4"
          >
            {recencyBucketLabel(bucket)}
          </Typography>
          {bucketChats.map(chat => (
            <ChatListRow key={chat.id} chat={chat} />
          ))}
        </div>
      ))}
      <InfiniteScrollSentinel
        dataLength={chats.length}
        hasMore={hasNextPage}
        onLoadMore={fetchNextPage}
      />
    </section>
  );
};
